import { fields } from 'iron-forge-react-modules';
import * as dataService from './dataService';



export type IAppEvent = dataService.IAppEvent;

export function genComponentAndControllerGenerator({
  orderId, returnAuthorizationId
}: {
  orderId?: string;
  returnAuthorizationId?: string;
} = {}) {
  return fields.ObjectSelectField.genComponentAndControllerGenerator({
    useGetObjects: () => dataService.useQuery({ orderId, returnAuthorizationId }),
    fnGetObjectLabel: object => object.displayName
  });
}

